<template>
    <div class="mainPage">
        <div class="stickyContent">
            <van-row class="popHeader">
                <van-col span="2" style="display: flex; align-items: center;"><van-icon name="arrow-left" size="20"
                        @click="backNavigation" /></van-col>
                <van-col span="20" class="Poptitle">{{ $t('common.toLookFor') }}</van-col>
            </van-row>

            <div class="searchField">
                <van-field v-model="localValue" type="text" :placeholder="$t('home.searchGames')" class="custom-field">
                    <template #right-icon>
                        <div class="left-section">
                            <img src="@/assets/themeThree/search_icon.png" alt="" width="10%" @click="searchGames">
                        </div>
                    </template>
                </van-field>
            </div>

            <div class="tabs">
                <van-tabs id="gameSearchTabs" :ellipsis="false" v-model:active="active" @click-tab="onClickTab">
                    <van-tab v-for="(item, index) in tabList" :title="$t(item.name)" :key="index" :name="item.id">
                        <template #title>
                            <div style="display: flex; align-items: center;">
                                <img :src="item.icon" alt="" width="20" style="padding-right: 10px;"> {{ $t(item.name)
                                }}
                            </div>
                        </template>
                    </van-tab>
                </van-tabs>
            </div>
        </div>


        <!-- Search games -->
        <div v-if="active == 1" class="gameContainer">
            <div v-if="gameSet?.gameList?.length < 1" class="noDataContainer">
                <img src="@/assets/themeThree/noSearchData.png" alt="" width="60%">
            </div>
            <van-row class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="8" class="game_item" v-for="(item, index) in gameSet?.gameList" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                                :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                                @update-game-categories="getGameTabData" />
                        </van-col>
                    </van-row>
                    <div v-if="gameSet?.gameList.length > 0" class="gameProgressBar">
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: gameSet?.gameList.length / gameSet.gameCount < 1 ? gameSet?.gameList.length * 100 / gameSet.gameCount + '%' : '100%' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${gameSet?.gameList.length * 100 / gameSet.gameCount}% - 6px)` }">
                            </div>
                        </div>
                        <div style="margin-left: 10px;">
                            {{ Math.round(gameSet?.gameList.length / gameSet.gameCount * 100) }}%
                        </div>
                    </div>
                    <div v-if="!gameSet?.loading && gameSet?.showLoadMore" class="load_more_btn" @click="loadMoreGame">
                        {{ $t('common.loadMore') }}
                        <img src="@/assets/common/loadMore.png" alt="">
                    </div>
                    <div v-if="gameSet?.loading" class="loading_btn">
                        <van-loading size="20" />
                        {{ $t('common.loading') }}
                    </div>
                </van-col>
            </van-row>
        </div> <!-- hot Games -->
        <div v-if="active == 2" class="gameContainer">
            <div v-if="hotGames?.length < 1" class="noDataContainer">
                <img src="@/assets/themeThree/noSearchData.png" alt="" width="60%">
            </div>
            <van-row v-else class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="8" class="game_item" v-for="(item, index) in hotGames" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                                :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                                @update-game-categories="getGameTabData" />
                        </van-col>
                    </van-row>
                </van-col>
            </van-row>
        </div>
        <!-- recente Games -->
        <div v-if="active == 3" class="gameContainer">
            <div v-if="recentGames?.length < 1" class="noDataContainer">
                <img src="@/assets/themeThree/noSearchData.png" alt="" width="60%">
            </div>
            <van-row v-else class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="8" class="game_item" v-for="(item, index) in recentGames" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                                :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                                @update-game-categories="getGameTabData" />
                        </van-col>
                    </van-row>
                </van-col>
            </van-row>
        </div>
        <!-- Favorite Games -->
        <div v-if="active == 4" class="gameContainer">
            <div v-if="favoriteGames?.length < 1" class="noDataContainer">
                <img src="@/assets/themeThree/noSearchData.png" alt="" width="60%">
            </div>
            <van-row v-else class="game_container">
                <van-col span="24" class="right_container">
                    <van-row>
                        <van-col span="8" class="game_item" v-for="(item, index) in favoriteGames" :key="index">
                            <GameCard :gameImage="item.customIcon"
                                @clickGameCard="GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                                :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                                @update-game-categories="getGameTabData" />
                        </van-col>
                    </van-row>
                </van-col>
            </van-row>
        </div>
    </div>

</template>
<script lang="ts" setup>
import { ref, computed, watch, inject, onMounted, nextTick } from 'vue';
import { debounce, fetchGameList, getGameSpecialCategories, goToPlayGame, TAB_LIST } from '@/view/home/supportScript';
import { useRouter } from 'vue-router';
import GameCard from '../game/components/gameCard.vue';
import { useGameStore } from '@/stores/games';
const PAGE_SIZE = 20
const router = useRouter()
const gameStore = useGameStore()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}
const tabList = ref(TAB_LIST)
const active = ref(2);
const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)
const hotGames = ref<any>([])
const recentGames = ref<any>([])
const favoriteGames = ref<any>([])
const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value
}))
const emits = defineEmits(['goToPlayGame'])
const backNavigation = () => {
    router.push('/home')
}

const loadMoreGame = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true

    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: number) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
// const debouncedSearch = debounce(() => {
//     resetList()
//     getGameList()
// }, 500)

// watch(localValue, () => {
//     debouncedSearch()
// })
const onClickTab = async (value: any) => {
    active.value = value.name
    localValue.value = ''
    gameList.value = [];
    showLoadMore.value = false

    await nextTick();

    setTimeout(() => {
        window.scrollTo(0, 0);

        const containers = document.querySelectorAll('.gameContainer');
        containers.forEach(el => {
            el.scrollTop = 0;
        });

        const rightContainers = document.querySelectorAll('.right_container');
        rightContainers.forEach(el => {
            el.scrollTop = 0;
        });
    }, 0);
}
const resetgameList = () => {
    favoriteGames.value = []
}
const getGameTabData = async () => {
    resetgameList()
    const { favoriteGameList, hotGameList, recentGameList } = await getGameSpecialCategories()
    favoriteGames.value = favoriteGameList
    recentGames.value = recentGameList
    hotGames.value = hotGameList
}
const searchGames = () => {
    active.value = 1
    resetList()
    getGameList()
}
onMounted(() => {
    getGameTabData()

})
defineExpose({
    openPopup
})
</script>
<style scoped>
.mainPage {
    background: #090f1e;
    min-height: 100vh;
}

.gamePopContainer {
    width: 80%;
    border-radius: 15px;
    background-color: #30241ce8;
}

.gamePopContainer::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    z-index: 10001 !important;
    backdrop-filter: blur(5px);
}

.stickyContent {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background: #090f1e;
    z-index: 100;
}

.popHeader {
    background: #090f1e;
    color: #fff;
    padding: 15px;
    z-index: 100;
}

.Poptitle {
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
}

.searchField {
    padding: 15px;
}

.left-section {
    display: flex;
    align-items: center;
}

.left-section img {
    width: 25px;
    padding: 0 10px;
}

.searchField>>>.van-cell {
    padding: 15px;
    font-size: 14px;
    align-items: center;
    background: #111629;
    border: 1px solid #363a5b6e;
    border-radius: 10px;
}

.searchField>>>.van-field__control {
    font-size: 14px;
    font-weight: bold;
    color: #fff;
}

.searchField ::v-deep(.van-field__control::placeholder) {
    color: #d6ddec53 !important;
    font-size: 14px !important;
    font-weight: 400;
    display: flex;
    align-items: center;
}

.gameContainer {
    padding: 0 5px;
    border-radius: 10px;
    height: 75vh;
    overflow-y: auto;
    margin: 0 15px;
    -webkit-overflow-scrolling: touch;
}

.gameContainer::-webkit-scrollbar {
    display: none;
}

.game_container {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
}

.right_container {
    height: auto;
    overflow-y: visible;
}

.right_container {
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-bottom: 20px;
}

.right_container::-webkit-scrollbar {
    display: none;
}

.game_item {
    padding: 5px;
}

.load_more_btn {
    font-size: 15px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    border-radius: 20px;
    padding: 10px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 10px 65px;

}

.load_more_btn img {
    width: 15px;
    height: 15px;
    opacity: 0.5;
    margin-left: 10px;
}

.loading_btn {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 25px;
    margin: 5px 65px;

}

.gameProgressBar {
    display: flex;
    align-items: center;
    margin: 5px 30%;
    color: #fff;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #0b7bde;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.tabs {
    margin-top: -10px;
    position: sticky;
    top: 60px;
    z-index: 10;
    background: #090F1F;
    padding: 10px 0px;
}

::v-deep #gameSearchTabs .van-tabs__nav {
    overflow-x: auto !important;
    white-space: nowrap !important;
}

::v-deep #gameSearchTabs .van-tab__text {
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: unset !important;
}

::v-deep #gameSearchTabs {
    --van-tabs-nav-background: transparent !important;

}

::v-deep #gameSearchTabs .van-tab--active {
    position: relative;
    --van-tab-active-text-color: #fff !important;
}

::v-deep #gameSearchTabs .van-tab--active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(0deg, rgba(10, 114, 210, 1), rgba(47, 157, 242, 1));
}

::v-deep #gameSearchTabs .van-tab {
    --van-tab-text-color: #6d788d !important;
    border-bottom: 1px solid rgba(58, 95, 131, 0.351);
}

::v-deep #gameSearchTabs .van-tabs__line {
    display: none;
}

.noDataContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20%;
}
</style>